import type { Auth0VueClient } from "@auth0/auth0-vue"
import { INVALID_REFRESH_TOKEN_ERROR_MESSAGE } from "@auth0/auth0-spa-js/src/constants"

// Pass in the auth0 client and return a callback that the engine can call to
// get the current Auth0 JWT.
export function tokenCallback(auth0: Auth0VueClient): () => Promise<string> {
  return async () => {
    try {
      return await auth0.getAccessTokenSilently()
    } catch (e) {
      // Reload in the event of an invalid or expired refresh token
      // This will get caught by the login guard and require re-login
      // either by Auth0 cookie or manual re-login
      if (
        e instanceof Error &&
        e.message &&
        e.message.includes(INVALID_REFRESH_TOKEN_ERROR_MESSAGE)
      ) {
        window.location.reload()
      }

      throw e
    }
  }
}
